import React, { useEffect, useState } from "react";

import ConfigList from "../components/ConfigList";

import { post } from "../utils/api";

import { userData } from "../../js/utils";

import "../css/Settings.css";

let json_campanias = [];

const tokenSesion = userData ? userData.token : "";

export default function PredeterminadosVentas(props) {
  const [campanias, setCampanias] = useState(json_campanias);

  const eliminarCampania = async (idCamp) => {
    props.createPopupQuestion(
      "¿Confirma qué desea eliminar el elemento actual?",
      () => {
        let json_delete = {
          token: tokenSesion,
          id: idCamp,
        };

        post("MotivosVenta/EliminarMotivoVenta.php", json_delete);

        json_campanias = json_campanias.filter((e) => e.id !== idCamp);
        setCampanias(json_campanias);
        props.removePopupQuestion();
      },
      () => props.removePopupQuestion(),
    );
  };

  const addCampania = async (camp) => {
    if (camp.trim() !== "") {
      let json_insert = {
        token: tokenSesion,
        descripcion: camp,
      };

      let newId = -1;

      await post("MotivosVenta/InsertarMotivoVenta.php", json_insert).then(
        (data) => {
          newId = data.id;
        },
      );

      if (newId !== -1) {
        let newCamp = { id: newId, descripcion: camp };
        json_campanias.push(newCamp);
        setCampanias(Array.from(json_campanias));
      }
    }
  };

  useEffect(() => {
    async function obtenerCampanias() {
      json_campanias = [];
      let jsonToken = { token: tokenSesion };
      json_campanias = await post(
        "MotivosVenta/ListarMotivosVenta.php",
        jsonToken,
      );
      setCampanias(json_campanias);
    }
    obtenerCampanias();
  }, []);

  if (!props.show) {
    return <></>;
  }

  return (
    <div className="cfg-section-fill">
      <ConfigList
        sectionDescription="Campañas"
        elements={campanias}
        deleteFunction={eliminarCampania}
        newText="Nueva campaña"
        insertFunction={addCampania}
      />
    </div>
  );
}
